export default __webpack_public_path__ + "static/property-c258ffc271243944d6a22d5d2d94a8f0.png";